const ITEMS = [
  "BMW SPECIALISTS",
  "DEALER-LEVEL DIAGNOSTICS",
  "24/7 BREAKDOWN RECOVERY",
  "HONEST FIXED PRICING",
  "SAGITTARIUS MOTOR WORKS",
  "EVERY REPAIR DONE ONCE",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="overflow-hidden border-b border-white/5 bg-[#0D1017] py-6" data-testid="marquee-section">
      <div className="animate-marquee flex w-max items-center gap-16">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-16">
            <span className="whitespace-nowrap font-display text-3xl uppercase tracking-[0.12em] text-slate-600 sm:text-4xl">
              {item}
            </span>
            <span className="text-amber-600/50">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
